import queryString from "query-string";

export const howToSale = ["روش فروش ۵","روش فروش ۴","روش فروش ۳","روش فروش ۲","روش فروش ۱"];

export function toEnglishDigits(str) {

    let  e = '۰'.charCodeAt(0);
    str = str.replace(/[۰-۹]/g, function(t) {
        return t.charCodeAt(0) - e;
    });
    return str;
}

export function price(x) {
    if(!!x){
        return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");

    }else {
        return x
    }
}

export function truncate(str, n){
    if(!!str){
        return (str.length > n) ? str.substr(0, n-1) + '...' : str;
    }else{
        return ''
    }
};
export function changeURL(queryStrong) {
    let url = queryString.stringifyUrl({url: window.location.href, query: queryStrong});
    window.history.replaceState(null, "",url);
}
export const currencySymbol = 'تومان';

export const AddressesLimit = 5;

export const colors = {
    "pending_for_call": "#ffea00",
    "not_answered": "#ff0000",
    "bad_customer": "#fa8023",
    "contract": "#38bf84",
    "maybe": "#567eb9",
    "done": "#007210",
    "end": "rgba(255,125,0,0.47)",
}
export function getName(person){
    if(!!person.name){
        return person.name;
    }else{
        return "کاربر"
    }
}
export const convertSeconds = (seconds) => {
    const hours = Math.floor(seconds / 3600)
    const minutes = Math.floor((seconds % 3600) / 60)
    const remainingSeconds = seconds % 60

    const hourString = hours > 0 ? hours < 10 ? `0${hours}` :`${hours}` : '00'
    const minuteString = minutes > 0 ? minutes < 10 ? `0${minutes}` : `${minutes}` : '00'
    const secondString =
        remainingSeconds > 0 ? remainingSeconds < 10 ? `0${remainingSeconds}` : `${remainingSeconds}` : '00'

    return `${hourString}:${minuteString}:${secondString}`
}